//*************************************************************************************
//* WaMS Component Framework - app.fileUpload.js
//* Version 0.1
//* Author: Huisenga
//* Component framework file upload plugin
//* Requires jQuery, WaMS Component Framework, fine uploader
//* 
//* Component tags file upload elements and intiailizes them using fine uploader
//* 
//*************************************************************************************
//2/23/18 Huisenga    [STUDYAB-339]: Added Binding for edit mode complete

app.fileUploaders = (function () {
    var myUploaders = {
        Init: function () {
            this.initFileUploadComponents();
        },
        initFileUploadComponents: function () {
            $(document).on("component-bind-edit-mode-complete", function (e, component) {
                $('[data-role~="file-Upload"]', component.el).each(function (i, fileUploadElement) {
                    app.fileUploaders.initFileUploadComponent(fileUploadElement);
                });
            });
            $('[data-role~="file-Upload"]').each(function (i, fileUploadElement) {
                app.fileUploaders.initFileUploadComponent(fileUploadElement);
            });
        },
        initFileUploadComponent: function (fileUploadElement) {
            var requestEndpoint = $(fileUploadElement).data('requestendpoint') ? $(fileUploadElement).data('requestendpoint') : '/Document/Upload';
            var deleteEndpoint = $(fileUploadElement).data('deleteendpoint') ? $(fileUploadElement).data('deleteendpoint') : '/Document/Delete';
            var multiUpload = $(fileUploadElement).data('multiupload') === "True";
            var allowedExtensions = $(fileUploadElement).data('allowedextensions');
            if (!allowedExtensions) {
                allowedExtensionArray = [];
            } else {
                allowedExtensionArray = allowedExtensions.split(',');
            }
            var sizeLimit = $(fileUploadElement).data('sizelimit');
            if (!sizeLimit) {
                sizeLimit = 0;
            }

            var uploader = new qq.FineUploader({
                debug: false,
                multiple: multiUpload,
                element: fileUploadElement,
                request: {
                    endpoint: requestEndpoint
                },
                deleteFile: {
                    enabled: true,
                    method: "POST",
                    endpoint: deleteEndpoint
                },
                callbacks: {
                    onComplete: function (id, name, response) {
                        if (response.success === true) {

                            //we have finished uploading. If you have any custom data returns, process them here
                            if (typeof response.fileName !== 'undefined')
                                this.setName(id, response.fileName);
                            app.fileUploaders.UpdateFile(this, id);
                        }
                    },
                    onStatusChange: function (id, oldStatus, newStatus) {
                            if (newStatus === 'upload successful') {
                                app.fileUploaders.UpdateFile(this, id);
                            }
                            else {
                                app.fileUploaders.RemoveFile(this, id);
                            }
                    }
                },
                thumbnails: {
                    placeholders: {
                        notAvailablePath: "/Content/placeholders/not_available-generic.png",
                        waitingPath: "/Content/placeholders/waiting-generic.png"
                    }
                },
                validation: {
                    allowedExtensions: allowedExtensionArray,
                    sizeLimit: sizeLimit
                },
                template: 'qq-simple-thumbnails-template'
            });
            if ($(".initfile", $(fileUploadElement)).length && !multiUpload) {
                //has init file, but is single upload
                //hide button
                $('.qq-upload-button-selector', $(fileUploadElement)).hide();
            }
            $(".initfile", $(fileUploadElement)).each(function () {
                if ($(this).data('initialfile-uuid') !== "") {
                    uploader.addInitialFiles([{
                        name: $(this).data('initialfile-name'),
                        uuid: $(this).data('initialfile-uuid'),
                        thumbnailUrl: $(this).data('initialfile-thumbnailurl'),
                        size: $(this).data('initialfile-size')
                    }]);
                }
            });
        }

    };
    myUploaders.UpdateFile = function (file, id) {
        var targetIdBase = $(file._options.element).data('target-id');
        if ($(file._options.element).data('multiupload') === "True") {
            var fileSet = $('#' + targetIdBase + '_fileset');

            var fileElement = $('[data-index="' + id + '"]', fileSet);
            if (!fileElement.length) {
                var newTemplate = $('.file-template .filespec', fileSet).clone();
                $('.templateField', newTemplate).each(function () {
                    var name = $(this).attr('name');
                    $(this).attr('name', name.replace('fileIndex', id));
                    var idVal = $(this).attr('id');
                    $(this).attr('id', idVal.replace('fileIndex', id));
                    $(this).val('');
                });

                $('.file-index', newTemplate).val(id);
                //$('.templateValidation', newTemplate).each(function () {
                //    var name = $(this).attr('data-valmsg-for');
                //    $(this).attr('data-valmsg-for', name.replace('feeIndex', newIndex));
                //});

                newTemplate.attr('data-index', id);

                //enable the fields
                $('input', newTemplate).removeAttr('disabled');

                fileSet.append(newTemplate);
                fileElement = newTemplate;
            }

            //an item in the fileset should now exist. Go ahead and update the data within
            $('.file-guid', fileElement).val(file.getUuid(id));
            $('.file-size', fileElement).val(file.getSize(id));
            $('.file-name', fileElement).val(file.getName(id));

        } else {
            //if single file, update the single file variables
            $('#' + targetIdBase + '_Guid').val(file.getUuid(id));
            $('#' + targetIdBase + '_Size').val(file.getSize(id));
            $('#' + targetIdBase + '_FileName').val(file.getName(id));

            $('.qq-upload-button-selector', $(file._options.element)).hide();
        }
        //$("form").data("unobtrusiveValidation", null);
        //$("form").data("validator", null);
        //$.validator.unobtrusive.parse($("form"));
    };

    myUploaders.RemoveFile = function (file, id) {
        var targetIdBase = $(file._options.element).data('target-id');
        if ($(file._options.element).data('multiupload') === "True") {
            //if multifile, find the dataset and remove this item. It will be readded if file completes
            var fileSet = $('#' + targetIdBase + '_fileset');
            $('[data-index="' + id + '"]', fileSet).remove();
        } else {
            //if single file, just empty out the params
            $('#' + targetIdBase + '_Guid').val('');
            $('#' + targetIdBase + '_Size').val('');
            $('#' + targetIdBase + '_FileName').val('');
            $('.qq-upload-button-selector', $(file._options.element)).show();
        }
    };
    return myUploaders;
}());
$(document).ready(function () {
    app.fileUploaders.Init();
});
